module.exports = __webpack_public_path__ + "static/media/icon-print.6f739684.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon-print.svg
// module id = 1574
// module chunks = 0